class TravelNursing {
	constructor(el) {
		this.el = el;

		this.setupEventHandlers();

	}

	setupEventHandlers() {
		const btn = this.el.querySelector('.button');
		
		btn.addEventListener('click', () => {
			
			this.buildDataObject();
			
		})
		
	}
	
	buildDataObject() {
		const selects = this.el.querySelectorAll('.travel-nursing-select');
		const prefiltrationVals = this.el.querySelectorAll('[data-prefiltration');

		const queryParams = {
			'job-type': 'null',
			'discipline': 'null',
			'job-skill': 'null',
			'shift': 'null',
			'state': 'null',
			'discipline-group': 'null'
		};
		
		selects.forEach(v => {
			const optionValue = v.getElementsByTagName('option')[0].innerHTML;
			let value = optionValue.replace(/\s+/g, '+').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\//g, '%2');
			
			if ( v.name === 'location' ) {
				value += `%2C+USA&location-type=administrative_area_level_1&location-short=${v.value}`;	
			}
			
			if (value.includes('...') === false) {
				queryParams[v.name] = value;
			}
			
		});
		
		prefiltrationVals.forEach(p => {
			
			const value = p.dataset.prefiltration;
			
			const index = value.indexOf("=");
			const keyValue = [ value.substring(0, index), value.substring(index+1) ];
			queryParams[keyValue[0]] = keyValue[1];
			
		})
		
		this.updateQueryParams(queryParams); 
		
		
	}

	updateQueryParams(params) {
		let queryStr = '';
		const url = 'https://work.aequor.com/browse-jobs?'
		
		Object.entries(params).forEach(k => {
			if (k[1] !== 'null') {
				queryStr += `${k[0]}=${k[1]}&`
			}
		});
		
		queryStr = queryStr.substring(0, queryStr.length - 1);
		
		window.open(url + queryStr, '_blank').focus();
		
	}
}

export default TravelNursing;